import { performRentalPortalListingsMassAction } from '../../../../../../api'
import {
  EMPTY_FUNCTION,
  EMPTY_LIST,
  EMPTY_OBJECT,
} from '../../../../../../constants/common'
import {
  useMassActions,
  useNotification,
  usePerformMassAction,
} from '../../../../../../hooks'
import { getPermanentFilters } from '../../../../../../utils/filter'
import {
  getListingsMassActionNotificationTitle,
  LISTING_MASS_ACTION_NAMES,
} from '../../../../../RentalPortalListing'
import { useListingProfileContext } from '../useListingProfileContext'

import { getIsListingProfileActionSucceeded } from './useListingProfilePerformAction.utils'

export function useListingProfilePerformAction({
  errorTitleKey = 'RentalPortal.ListingMassActionErrorKey',
  sub,
  onSuccess,
}) {
  const { handleCloseModal, handleEntityReload, listingData } =
    useListingProfileContext()

  const { handleAddErrorNotification } = useNotification()

  const {
    getAsyncTaskId,
    handleAddAsyncMassActionNotification,
    handleAddFinishMassActionNotification,
  } = useMassActions({
    getNotificationTitle: getListingsMassActionNotificationTitle,
    onSuccessHandler: handleEntityReload,
  })

  function handleErrorAction() {
    handleAddErrorNotification(errorTitleKey)
  }

  function handleAddFinishNotification(data, params) {
    handleAddFinishMassActionNotification(data, params)

    if (getIsListingProfileActionSucceeded(data)) {
      onSuccess()
    }
  }

  const { massAction } = usePerformMassAction({
    excludeIds: EMPTY_LIST,
    filterValues: getPermanentFilters({ sub }),
    getAsyncTaskId,
    massActionNames: LISTING_MASS_ACTION_NAMES,
    pagination: EMPTY_OBJECT,
    performApi: performRentalPortalListingsMassAction,
    selectAllPages: false,
    selectedIds: EMPTY_LIST,
    onAddAsyncMassActionNotification: handleAddAsyncMassActionNotification,
    onAddFinishMassActionNotification: handleAddFinishNotification,
    onCleanSelection: EMPTY_FUNCTION,
    onCloseModal: handleCloseModal,
    onErrorAction: handleErrorAction,
    onReload: EMPTY_FUNCTION,
  })

  function handlePerformAction(action) {
    massAction({ action, ids: listingData.id })
  }

  return { handlePerformAction }
}
